// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3RdRP","title":"ClientReferral_title__1LWkx","itemText":"ClientReferral_itemText__eaMxR"};